import { Tenant } from '@/states/auth.state';

export const isSubscriptionExpired = (tenant: Tenant | undefined): boolean => {
  if (!tenant || !tenant.subscription) {
    return false;
  }

  const { status, ends_at } = tenant.subscription;

  if (status === 'expired') {
    return true;
  }

  if (ends_at) {
    const endDate = new Date(ends_at);
    const now = new Date();
    return endDate < now;
  }

  return false;
};

export const getSubscriptionMessage = (tenant: Tenant | undefined): string | null => {
  if (!tenant || !tenant.subscription) {
    return null;
  }

  const expired = isSubscriptionExpired(tenant);

  if (expired) {
    return 'Subscription Anda telah berakhir. Checklist hanya dapat dilihat, tidak dapat diedit.';
  }

  return null;
};

export const getTrialDaysRemaining = (tenant: Tenant | undefined): number | null => {
  if (!tenant?.subscription?.trial_ends_at) return null;

  const trialEnd = new Date(tenant.subscription.trial_ends_at);
  const now = new Date();
  const diffMs = trialEnd.getTime() - now.getTime();
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffDays >= 0 && diffDays <= 3) return diffDays;
  return null;
};

const MONTH_NAMES_ID = [
  'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
  'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember',
];

export const getSubscriptionEndDate = (tenant: Tenant | undefined): string | null => {
  if (!tenant?.subscription?.ends_at) return null;

  const endDate = new Date(tenant.subscription.ends_at);
  const now = new Date();
  if (endDate >= now) return null;

  const day = endDate.getDate();
  const month = MONTH_NAMES_ID[endDate.getMonth()];
  const year = endDate.getFullYear();
  return `${day} ${month} ${year}`;
};
